<template>
	<div class="pl-4 pr-4">
		<PollStats v-if="collaboration.type == 'poll'" :id="collaboration.id" :title="title"></PollStats>
		<DelegationStats v-if="collaboration.type == 'delegation'" :id="collaboration.id" :title="title"></DelegationStats>
	</div>
</template>

<style lang="less">
	.collab-label {
		width: 100%;
		display: block;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import PollStats from "@/components/assessment/collaborations/PollStats"
	import DelegationStats from "@/components/assessment/collaborations/DelegationStats"
	export default {
		name: "CollaborationStats", 
		props: {
			id: {type: String}, 
			title: {type: Boolean, default: true }
		},
		data: () => {
			return {

			}
		},
		components: {
			PollStats,
			DelegationStats
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations || []
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>